import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { platformAtom, setPlatformAction } from '@root/entities/platform'
import { Platform } from '@root/entities/platform/model'
import { PremiumRoute, useAppRoutes } from '@root/features/routing'
import { routerLocationAtom } from '@root/shared/lib/react-router'

import { platforms } from '../../../model/platform'

import { PlatformSelectorItem } from './platform-selector-item'

type Props = {
  expanded: boolean
}

export const PlatformSelector: React.FC<Props> = ({ expanded }: Props) => {
  const [platform] = useAtom(platformAtom)
  const setPlatform = useAction(setPlatformAction)
  const [location] = useAtom(routerLocationAtom)

  const {
    navigateToPremiumIndex,
    navigateToRoot,
    navigateToNft,
    navigateToFunExplore,
  } = useAppRoutes()

  const handleClick = (platform: Platform.Platform) => {
    if (platform === Platform.Premium) {
      navigateToPremiumIndex()
    }
    if (platform === Platform.Terminal) {
      setPlatform(Platform.Terminal)
      navigateToRoot()
    }
    if (platform === Platform.NFT) {
      setPlatform(Platform.NFT)
      navigateToNft()
    }
    if (platform === Platform.Pump) {
      setPlatform(Platform.Pump)
      navigateToFunExplore()
    }
  }

  const selectedPlatform = useMemo(() => {
    if (PremiumRoute.match(location.pathname)) {
      return Platform.Premium
    }
    return platform
  }, [location.pathname, platform])

  return (
    <Root aria-expanded={expanded}>
      <Items>
        {platforms.map((item, index) => {
          const variant = item === selectedPlatform ? 'filled' : 'outlined'

          return (
            <PlatformSelectorItem
              key={item}
              expanded={expanded}
              platform={item}
              onClick={() => handleClick(item)}
              variant={variant}
              withSeparator={index !== platforms.length - 1}
            />
          )
        })}
      </Items>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  padding-inline: 3.5px 3px;
  width: 100%;
`

const Items = styled.div`
  border-radius: 8px;
  background: var(--backgroundA-2);

  display: grid;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 6px;
  padding-inline-end: 5.5px;
  transition: padding 0.1s ease-in-out;

  @container sidebar (height <= 700px) {
    gap: 2px;
  }
`
